module.exports = __webpack_public_path__ + "static/media/login_warning.2fe90553.png";